import Entity from './entity'

const UploadRule = new Entity('uploadrules')

export default UploadRule
